export const MOMENTS_CLIPS = 'MOMENTS-CLIPS';
export const MOMENTS_PLAYLISTS = 'MOMENTS-PLAYLISTS';
export const MOMENTS_COLLECTIONS = 'MOMENTS_COLLECTIONS';
export const FILTER_BY_TITLE = 'FILTER-BY-TITLE';
export const FILTER_BY_TAG = 'FILTER-BY-TAG';
export const EDIT_MOMENT_CLIP = 'EDIT-MOMENT-CLIP';
export const SAVE_MOMENT_CLIP = 'SAVE-MOMENT-CLIP';
export const ADD_NEW_MOMENT_CLIP = 'ADD-NEW-MOMENT-CLIP';
export const DELETE_MOMENT_CLIP = 'DELETE-MOMENT-CLIP';
export const NEW_CLIP_MOMENT = 'NEW-CLIP-MOMENT';
export const SEARCH_WITH_CLIP_TITLE = 'SEARCH-WITH-CLIP-TITLE';
export const SEARCH_WITH_CLIP_CID = 'SEARCH-WITH-CLIP-CID';
export const EDIT_MOMENT_PLAYLIST = 'EDIT-MOMENT-PLAYLIST';
export const DELETE_MOMENT_PLAYLIST = 'DELETE-MOMENT-PLAYLIST';
export const CREATE_NEW_PLAYLIST = 'CREATE-NEW-PLAYLIST';
export const UPLOAD_THUMBNAIL = 'UPLOAD-THUMBNAIL';
export const SAVE_MOMENT_PLAYLIST = 'SAVE-MOMENT-PLAYLIST';
export const MOMENT_CHAMPIONSHIP = 'MOMENT-CHAMPIONSHIP';
export const REORDER_MOMENT_PLAYLIST = 'REORDER-MOMENT-PLAYLIST';
export const DELETE_CLIP_FROM_MOMENT_PLAYLIST = 'DELETE-CLIP-FROM-MOMENT-PLAYLIST';
export const CREATE_NEW_COLLECTION = 'CREATE-NEW-COLLECTION';
export const SAVE_COLLECTION_ORDER = 'SAVE-COLLECTION-ORDER';
export const REORDER_MULTIPLE_COLLECTION = 'REORDER-MULTIPLE-COLLECTION';
export const SAVE_COLLECTION = 'SAVE-COLLECTION';
export const DELETE_COLLECTION = 'DELETE_COLLECTION';
export const SEARCH_COLLECTION_MOMENT_CLIP_TITLE = 'SEARCH-COLLECTION-MOMENT-CLIP-TITLE';
export const SEARCH_COLLECTION_MOMENT_CLIP_ID = 'SEARCH-COLLECTION-MOMENT-CLIP-ID';
export const DELETE_PLAYLIST_FROM_COLLECTION = 'DELETE-PLAYLIST-FROM-COLLECTION';